import * as XLSX from 'xlsx';

import { generateExcelFile, parseExcelFile } from './excelParser';


export { generateExcelFile, parseExcelFile };

export const PROVINCE_TEMPLATE_COLUMNS = [
  'Nombre y Apellido',
  'WhatsApp',
  'DNI',
  'Provincia',
  'Distrito',
  'Direccion',
  'Direccion de Agencia',
  'SKU 1',
  'Cantidad 1',
  'SKU 2',
  'Cantidad 2',
  'SKU 3',
  'Cantidad 3',
  'SKU 4',
  'Cantidad 4',
  'SKU 5',
  'Cantidad 5',
  'Cobrar',
  'Adelanto',
  'Notas',
];

export function downloadProvinceExcelTemplate(provinces = [], userProducts = []) {
  const firstProduct = userProducts[0];
  const secondProduct = userProducts[1];
  const exampleProvince = provinces.includes('Arequipa') ? 'Arequipa' : (provinces[0] || 'Arequipa');
  const templateRows = [
    PROVINCE_TEMPLATE_COLUMNS,
    [
      'Maria Garcia',
      '987654321',
      '12345678',
      exampleProvince,
      'Cercado',
      'Calle Los Geranios 456',
      'Agencia Centro - Jr. Lima 123',
      firstProduct?.sku || 'REEMPLAZAR-SKU',
      '1',
      secondProduct?.sku || '',
      secondProduct ? '1' : '',
      '', '', '', '', '', '',
      '89.90',
      '',
      'Llamar antes de enviar',
    ],
  ];

  const instructions = [
    ['INSTRUCCIONES - CARGA MASIVA DE PROVINCIA'],
    [''],
    ['La fecha reservada para el servicio se selecciona en Fast Max y se aplica a todo el lote.'],
    ['No agregue una columna de fecha.'],
    ['El comprobante de pago no se carga mediante este Excel.'],
    ['El adelanto es opcional; si se deja vacio se registra como S/ 0.00.'],
    [''],
    ['CAMPOS OBLIGATORIOS'],
    ['- Nombre y Apellido'],
    ['- WhatsApp: exactamente 9 digitos'],
    ['- Provincia: copie el nombre de la pestana Provincias'],
    ['- Distrito'],
    ['- Direccion'],
    ['- Direccion de Agencia'],
    ['- SKU 1; Cantidad 1 usa 1 por defecto'],
    [''],
    ['CAMPOS OPCIONALES'],
    ['- DNI: si se completa debe tener 8 digitos'],
    ['- SKU 2-5 y Cantidad 2-5'],
    ['- Cobrar'],
    ['- Adelanto'],
    ['- Notas'],
  ];

  const provinceRows = [
    ['PROVINCIAS DISPONIBLES'],
    [''],
    ...provinces.map(province => [province]),
  ];
  const productRows = [
    ['PRODUCTOS DISPONIBLES'],
    [''],
    ['SKU', 'Producto', 'Precio', 'Stock Fast Max'],
    ...userProducts.map(product => [
      product.sku,
      product.title,
      product.price,
      product.available_quantity ?? 0,
    ]),
  ];

  const templateSheet = XLSX.utils.aoa_to_sheet(templateRows);
  const instructionsSheet = XLSX.utils.aoa_to_sheet(instructions);
  const provincesSheet = XLSX.utils.aoa_to_sheet(provinceRows);
  const productsSheet = XLSX.utils.aoa_to_sheet(productRows);

  templateSheet['!cols'] = PROVINCE_TEMPLATE_COLUMNS.map((column) => ({
    wch: column.includes('Direccion') ? 32 : column.includes('Nombre') ? 22 : 15,
  }));
  instructionsSheet['!cols'] = [{ wch: 100 }];
  provincesSheet['!cols'] = [{ wch: 30 }];
  productsSheet['!cols'] = [{ wch: 18 }, { wch: 38 }, { wch: 12 }, { wch: 18 }];

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, templateSheet, 'Plantilla');
  XLSX.utils.book_append_sheet(workbook, instructionsSheet, 'Instrucciones');
  XLSX.utils.book_append_sheet(workbook, provincesSheet, 'Provincias');
  XLSX.utils.book_append_sheet(workbook, productsSheet, 'Productos');
  XLSX.writeFile(workbook, 'Plantilla_Carga_Masiva_Provincia_FastMax.xlsx');
}
